var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.668,
    height: 28.773,
    viewBox: "0 0 28.668 28.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M14.334.563A14.387,14.387,0,1,0,28.668,14.949,14.358,14.358,0,0,0,14.334.563Zm0,5.569a5.105,5.105,0,1,1-5.086,5.1A5.1,5.1,0,0,1,14.334,6.132Zm0,19.956a11.06,11.06,0,0,1-8.468-3.956,6.441,6.441,0,0,1,5.693-3.469,1.41,1.41,0,0,1,.41.064,7.627,7.627,0,0,0,2.364.4,7.6,7.6,0,0,0,2.364-.4,1.409,1.409,0,0,1,.41-.064A6.441,6.441,0,0,1,22.8,22.131,11.06,11.06,0,0,1,14.334,26.087Z",
    transform: "translate(0 -0.563)",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.33d76887b510349d1e6dd00e5608911e.svg";
export { ForwardRef as ReactComponent };